import { cx } from "@jugl-web/utils";
import { ReactNode, forwardRef } from "react";

export interface LiveChatUIContentScrollableProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUIContentScrollable = forwardRef<
  HTMLDivElement,
  LiveChatUIContentScrollableProps
>(({ children, className }, ref) => {
  return (
    <div
      ref={ref}
      className={cx(
        "jugl__custom-scrollbar relative flex h-full flex-col overflow-y-auto",
        className
      )}
    >
      {children}
    </div>
  );
});

LiveChatUIContentScrollable.displayName = "LiveChatUIContentScrollable";
